export default __webpack_public_path__ + "static/media/shirt9.6933653d.jpeg";